import { render, staticRenderFns } from "./placement-block.vue?vue&type=template&id=6dd8c87e&scoped=true"
import script from "./placement-block.vue?vue&type=script&lang=js"
export * from "./placement-block.vue?vue&type=script&lang=js"
import style0 from "./placement-block.vue?vue&type=style&index=0&id=6dd8c87e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd8c87e",
  null
  
)

export default component.exports